import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import "carbon-components/scss/globals/scss/styles.scss";
import './index.scss';
import { LicenseManager } from 'ag-grid-enterprise'
import App from './App';
import { TenantConfigProvider } from './context/TenantConfigContext';

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID);

// Sentry.init({
//   dsn: "https://d5815ddbcbaf40eea629a6202ed31548@o46191.ingest.sentry.io/6328348",
//   integrations: [new BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//   debug: true,
// });

ReactDOM.render(
    <BrowserRouter>
      <TenantConfigProvider>
        <App />
      </TenantConfigProvider>
    </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
